import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface VerifyDataElapsedTimeProps {
  startedAt: string | Date;
}

const formatElapsedTime = (elapsedMs: number) => {
  const elapsedMinutes = Math.floor(elapsedMs / (1000 * 60));
  const elapsedSeconds = Math.floor((elapsedMs % (1000 * 60)) / 1000);

  if (elapsedMinutes >= 60) {
    const elapsedHours = Math.floor(elapsedMinutes / 60);
    return `${elapsedHours}h ${elapsedMinutes % 60}m ${elapsedSeconds}s`;
  }

  return `${elapsedMinutes}m ${elapsedSeconds}s`;
};

const VerifyDataElapsedTime: React.FC<VerifyDataElapsedTimeProps> = ({ startedAt }) => {
  const [currentTime, setCurrentTime] = useState(Date.now());
  const startedAtMs = new Date(startedAt).getTime();
  const elapsedMs = Math.max(0, currentTime - startedAtMs);

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" sx={{ color: '#1976d2' }}>
          Started: {new Date(startedAt).toLocaleTimeString()}
        </Typography>
        <Typography variant="caption" sx={{ color: '#1976d2' }}>
          • Elapsed: {formatElapsedTime(elapsedMs)}
        </Typography>
      </Box>
      {elapsedMs > 1000 * 60 * 60 && (
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          padding: '8px 12px',
          backgroundColor: '#fff3e0',
          border: '1px solid #ffb74d',
          borderRadius: '4px'
        }}>
          <Typography variant="caption" sx={{ color: '#e65100', fontWeight: '500' }}>
            ⚠️ This shouldn't be taking this long, contact an admin
          </Typography>
        </Box>
      )}
    </>
  );
};

export default VerifyDataElapsedTime;
